import createDataContext from "./createDataContext";
import { db, auth, storage } from "../firebase";

const kitReducer = (state, action) => {
  switch (action.type) {
    case "add_key":
      return { ...state, kitID: action.payload };
    case "add_videoFile":
      return { ...state, videoFile: action.payload };
    case "add_imageFile":
      return { ...state, imageFile: action.payload };
    case "add_profileFile":
      return { ...state, profileFile: action.payload };
    case "add_messageText":
      return { ...state, messageText: action.payload };
    case "upload_file":
      return { ...state, videoFile: action.payload };
    case "save_kit":
      return { ...state, saveStatus: action.payload };
    case "get_kit":
      return {
        ...state,
        kitID: action.payload.kitID,
        videoFile: action.payload.videoFile,
        messageText: action.payload.messageText,
        profileFile: action.payload.profileFile,
        imageFile: action.payload.imageFile,
        video: action.payload.video,
      };
    default:
      return state;
  }
};

const setKitID = (dispatch) => (kitID) => {
  dispatch({ type: "add_key", payload: kitID });
};

const setVideoFile = (dispatch) => (fileURL) => {
  dispatch({ type: "add_videoFile", payload: fileURL });
};

const setMessageText = (dispatch) => (messageText) => {
  dispatch({ type: "add_messageText", payload: messageText });
};

const setImageFile = (dispatch) => (fileURL) => {
  dispatch({ type: "add_imageFile", payload: fileURL });
};

const setProfileFile = (dispatch) => (fileURL) => {
  dispatch({ type: "add_profileFile", payload: fileURL });
};

const saveKit = (dispatch) => async (
  kitID,
  videoFile,
  messageText,
  imageFile,
  profileFile,
  video
) => {
  // const db = firebaseApp.firestore();
  // need to add save routine to firbase
  auth
    .signInWithEmailAndPassword("thjeon.wa@play-xyz.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      const errorMessage = error.message;
      console.log(errorMessage);
      return;
    });

  const time = Date.now();

  let aKit = {
    videoFile: videoFile,
    messageText: messageText,
    imageFile: imageFile,
    profileFile: profileFile,
    video: video,
    register_time: time,
  };

  // db.collection("kits")
  //   .doc(kitID)
  //   .set(aKit)
  //   .then(() => {
  //     console.log("kit saved");
  //     dispatch({ type: "save_kit", payload: "OK" });
  //   })
  //   .catch((error) => {
  //     console.log("error", error);
  //     dispatch({ type: "save_kit", payload: error });
  //   });
  await db.collection("kits").doc(kitID).set(aKit);
  console.log("kit saved");
  dispatch({ type: "save_kit", payload: "OK" });
};

const getKit = (dispatch) => async (kitID) => {
  console.log("getKit with " + kitID);

  auth
    .signInWithEmailAndPassword("thjeon.wa@play-xyz.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorMessage);
      return;
    });

  const data = await db.collection("kits").doc(kitID).get();

  let aKit = null;
  if (data.exists) {
    aKit = data.data();
    aKit.kitID = kitID;
    dispatch({ type: "get_kit", payload: aKit });
  } else {
    console.log("error in loading");
  }
};

const uploadVideoFile = (dispatch) => async (file, filename) => {
  console.log(`upload file to firebase storage: ${file.name}`);
  storage.ref(`videos/${filename}`).put(file);
  storage
    .ref(`videos/${filename}`)
    .getDownloadURL()
    .then((url) => {
      console.log("URL", url);
      dispatch({ type: "upload_file", payload: url });
    });
};

export const { Context, Provider } = createDataContext(
  kitReducer,
  {
    setKitID,
    setVideoFile,
    setImageFile,
    setProfileFile,
    setMessageText,
    saveKit,
    getKit,
    uploadVideoFile,
  },
  {
    kitID: "",
    videoFile: "",
    messageText: "",
    imageFile: "",
    profileFile: "",
    video: "",
    saveStatus: "",
  }
);
